// import "gantt-task-react/dist/index.css";
// import React from "react";
// import { ViewMode } from "gantt-task-react";
// import "./stylefortimeline.css";
// export const ViewSwitcher = ({
//   onViewModeChange,
//   onViewListChange,
//   isChecked,
// }) => {
//   return (
//     <div className="TViewContainer">
//       <div className="TSwitch" style={{ marginRight: "720px" }}>
//         <span> Show Task List</span>
//         <label className="TSwitch_Toggle ml-1">
//           <input
//             type="checkbox"
//             defaultChecked={isChecked}
//             onClick={() => onViewListChange(!isChecked)}
//           />
//           <span className="TSlider" />
//         </label>
//       </div>
//       {/* <button className='TButton' onClick={() => onViewModeChange(ViewMode.Hour)}>
//         Hour
//       </button>
//       <button className='TButton' onClick={() => onViewModeChange(ViewMode.QuarterDay)}>
//         Quarter of Day
//       </button>
//       <button className='TButton' onClick={() => onViewModeChange(ViewMode.HalfDay)}>
//         Half of Day
//       </button> */}
//       <div>
//         <button
//           className="TButton border rounded"
//           onClick={() => onViewModeChange(ViewMode.Day)}
//         >
//           Day
//         </button>
//         <button
//           className="TButton border rounded"
//           onClick={() => onViewModeChange(ViewMode.Week)}
//         >
//           Week
//         </button>
//         <button
//           className="TButton border rounded"
//           onClick={() => onViewModeChange(ViewMode.Month)}
//         >
//           Month
//         </button>
//       </div>

//       {/* <div className="TSwitch">
//         <label className="TSwitch_Toggle">
//           <input
//             type="checkbox"
//             defaultChecked={isChecked}
//             onClick={() => onViewListChange(!isChecked)}
//           />
//           <span className="TSlider" />
//         </label>
//         Show Task List
//       </div> */}
//     </div>
//   );
// };
import "gantt-task-react/dist/index.css";
import React, { useState } from "react";
import { ViewMode } from "gantt-task-react";
import "./stylefortimeline.css";

export const ViewSwitcher = ({
  onViewModeChange,
  onViewListChange,
  isChecked,
}) => {
  // State to track the active button
  const [activeMode, setActiveMode] = useState(ViewMode.Month);

  const handleModeChange = (mode) => {
    setActiveMode(mode); // Set the active mode
    onViewModeChange(mode); // Call the parent function
  };

  return (
    <div className="TViewContainer">
      <div className="TSwitch" style={{ marginRight: "720px" }}>
        <span> Show Task List</span>
        <label className="TSwitch_Toggle ml-1">
          <input
            type="checkbox"
            defaultChecked={isChecked}
            onClick={() => onViewListChange(!isChecked)}
          />
          <span className="TSlider" />
        </label>
      </div>

      {/* View Mode Buttons */}
      <div>
        <button
          className={`TButton border rounded ${
            activeMode === ViewMode.Day ? "active" : ""
          }`}
          onClick={() => handleModeChange(ViewMode.Day)}
        >
          Day
        </button>
        <button
          className={`TButton border rounded ${
            activeMode === ViewMode.Week ? "active" : ""
          }`}
          onClick={() => handleModeChange(ViewMode.Week)}
        >
          Week
        </button>
        <button
          className={`TButton border rounded ${
            activeMode === ViewMode.Month ? "active" : ""
          }`}
          onClick={() => handleModeChange(ViewMode.Month)}
        >
          Month
        </button>
      </div>
    </div>
  );
};
